import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConfigSettingService {
  public Environment: string = "Production"; // Local, Stage, Production
 
  PrintConsole: boolean = true;
  public BaseUlr: string = "";
  constructor() { }
  
  getBaseUrl() {
    if (this.Environment === "Local") {
      return "http://localhost:3022/";
    }
    else if (this.Environment === "Stage") {
      // return "https://manashakti3026.loca.lt/";
        return "http://13.234.47.193:3022/";
    }
    else if (this.Environment === "Production") {
      // return "http://13.127.84.145:3022/"
      return "https://onlineselftests.manashakti.org/"
    }
  }
}
